import { default as _91id_93XZwZhIIZQzMeta } from "D:/win_www/powerflow/powerflow-site/pages/[site]/[model]/[id].vue?macro=true";
import { default as indexgbpPuyFDbHMeta } from "D:/win_www/powerflow/powerflow-site/pages/[site]/[model]/index.vue?macro=true";
import { default as _91page_93c2iWYsPnChMeta } from "D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/[tenant]/[page].vue?macro=true";
import { default as indexvYwFcaZunoMeta } from "D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/[tenant]/index.vue?macro=true";
import { default as indexaqcG3G1heTMeta } from "D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/index.vue?macro=true";
import { default as tenantsQslGOwCNkdMeta } from "D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/tenants.vue?macro=true";
import { default as usersM0oJYKi1nPMeta } from "D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/users.vue?macro=true";
import { default as indexHXN1Afgm1cMeta } from "D:/win_www/powerflow/powerflow-site/pages/[site]/index.vue?macro=true";
import { default as _91id_93I30RarXHC0Meta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model]/[id].vue?macro=true";
import { default as index8oyGHIQij5Meta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model]/index.vue?macro=true";
import { default as _91model_93Ko6WGd5n5gMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model].vue?macro=true";
import { default as chatbot7fmuvLG5GyMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/chatbot.vue?macro=true";
import { default as _91id_93QuNZ5IDUk9Meta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents/[id].vue?macro=true";
import { default as indexuAUKEcER6ZMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents/index.vue?macro=true";
import { default as documentstnJlUdVXK6Meta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents.vue?macro=true";
import { default as dynamicsBdm0F3huytMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/dynamics.vue?macro=true";
import { default as emailsJRe8jjjWoPMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/emails.vue?macro=true";
import { default as indexq3XnS4NRNoMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/index.vue?macro=true";
import { default as notificationsu55TCjN6iGMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/notifications.vue?macro=true";
import { default as impostazioniNENHafAPEgMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni.vue?macro=true";
import { default as indexOpWOUD8HtAMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/index.vue?macro=true";
import { default as _91id_93o9f9kOhRJnMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents/[id].vue?macro=true";
import { default as indexOElVXGHpoaMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents/index.vue?macro=true";
import { default as public_documentsM3kaHcDvOIMeta } from "D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents.vue?macro=true";
import { default as change_45password61fEqpBNrxMeta } from "D:/win_www/powerflow/powerflow-site/pages/change-password.vue?macro=true";
import { default as index1R6E5vvjTbMeta } from "D:/win_www/powerflow/powerflow-site/pages/index.vue?macro=true";
import { default as logins2b4HciqaTMeta } from "D:/win_www/powerflow/powerflow-site/pages/login.vue?macro=true";
import { default as reset_45passwordwkhnU4ETs3Meta } from "D:/win_www/powerflow/powerflow-site/pages/reset-password.vue?macro=true";
export default [
  {
    name: "site-model-id",
    path: "/:site()/:model()/:id()",
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/[site]/[model]/[id].vue")
  },
  {
    name: "site-model",
    path: "/:site()/:model()",
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/[site]/[model]/index.vue")
  },
  {
    name: "site-admin-tenant-page",
    path: "/:site()/admin/:tenant()/:page()",
    component: () => import("D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/[tenant]/[page].vue")
  },
  {
    name: "site-admin-tenant",
    path: "/:site()/admin/:tenant()",
    component: () => import("D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/[tenant]/index.vue")
  },
  {
    name: "site-admin",
    path: "/:site()/admin",
    component: () => import("D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/index.vue")
  },
  {
    name: "site-admin-tenants",
    path: "/:site()/admin/tenants",
    component: () => import("D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/tenants.vue")
  },
  {
    name: "site-admin-users",
    path: "/:site()/admin/users",
    component: () => import("D:/win_www/powerflow/powerflow-site/admin/pages/[site]/admin/users.vue")
  },
  {
    name: "site",
    path: "/:site()",
    meta: indexHXN1Afgm1cMeta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/[site]/index.vue")
  },
  {
    name: _91model_93Ko6WGd5n5gMeta?.name,
    path: "/:site()/procedure/:model()",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model].vue"),
    children: [
  {
    name: "site-procedure-model-id",
    path: ":id()",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model]/[id].vue")
  },
  {
    name: "site-procedure-model",
    path: "",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/[model]/index.vue")
  }
]
  },
  {
    name: "site-procedure-chatbot",
    path: "/:site()/procedure/chatbot",
    meta: chatbot7fmuvLG5GyMeta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/chatbot.vue")
  },
  {
    name: documentstnJlUdVXK6Meta?.name,
    path: "/:site()/procedure/documents",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents.vue"),
    children: [
  {
    name: "site-procedure-documents-id",
    path: ":id()",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents/[id].vue")
  },
  {
    name: "site-procedure-documents",
    path: "",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/documents/index.vue")
  }
]
  },
  {
    name: impostazioniNENHafAPEgMeta?.name,
    path: "/:site()/procedure/impostazioni",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni.vue"),
    children: [
  {
    name: "site-procedure-impostazioni-dynamics",
    path: "dynamics",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/dynamics.vue")
  },
  {
    name: "site-procedure-impostazioni-emails",
    path: "emails",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/emails.vue")
  },
  {
    name: "site-procedure-impostazioni",
    path: "",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/index.vue")
  },
  {
    name: "site-procedure-impostazioni-notifications",
    path: "notifications",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/impostazioni/notifications.vue")
  }
]
  },
  {
    name: "site-procedure",
    path: "/:site()/procedure",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/index.vue")
  },
  {
    name: public_documentsM3kaHcDvOIMeta?.name,
    path: "/:site()/procedure/public_documents",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents.vue"),
    children: [
  {
    name: "site-procedure-public_documents-id",
    path: ":id()",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents/[id].vue")
  },
  {
    name: "site-procedure-public_documents",
    path: "",
    component: () => import("D:/win_www/powerflow/powerflow-site/procedure/pages/[site]/procedure/public_documents/index.vue")
  }
]
  },
  {
    name: "change-password",
    path: "/change-password",
    meta: change_45password61fEqpBNrxMeta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/change-password.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1R6E5vvjTbMeta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logins2b4HciqaTMeta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/login.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordwkhnU4ETs3Meta || {},
    component: () => import("D:/win_www/powerflow/powerflow-site/pages/reset-password.vue")
  }
]